import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CookieService } from './cookie.service';

const SESSION_KEY = 'crescio-tracked';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly cookies = inject(CookieService);

  /** Registra la visita una vez por sesión. Solo actúa si el usuario aceptó cookies. */
  trackVisit(): void {
    if (!this.cookies.isAccepted()) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, '1');

    const ref = new URLSearchParams(window.location.search).get('ref') ?? 'direct';

    fetch(`${environment.apiUrl}/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ref, userAgent: navigator.userAgent }),
      keepalive: true,
    }).catch(() => {
      // Analytics nunca debe romper el sitio
    });
  }
}
